module.exports = __webpack_public_path__ + "img/cw.1775b444.svg";